function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M 15 4 L 15 20.5625 L 9.71875 15.28125 L 8.28125 16.71875 L 15.28125 23.71875 L 16 24.40625 L 16.71875 23.71875 L 23.71875 16.71875 L 22.28125 15.28125 L 17 20.5625 L 17 4 L 15 4 z M 7 26 L 7 28 L 25 28 L 25 26 L 7 26 z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/download.586afc37.svg";
export { SvgComponent as ReactComponent };